<template>
  <div class="px-10">
    <Carousel :settings="settings">
      <slide v-for="(photo, i) in photos" :key="i">
        <img
          class="max-w-auto h-[420px] w-[672px] object-cover"
          :src="photo"
          alt=""
        />
      </slide>

      <template #addons>
        <Navigation></Navigation>
        <Pagination></Pagination>
      </template>
    </Carousel>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

export default {
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },

  setup() {
    const photos = [
      "/img/galerie/2.JPG",
      "/img/galerie/24.JPG",
      "/img/galerie/31.JPG",
      "/img/galerie/8.JPG",
      "/img/galerie/5.JPG",
      "/img/galerie/13.JPG",
      "/img/galerie/32.JPG",
    ];

    return {
      photos,
    };
  },

  data() {
    return {
      settings: {
        itemsToShow: 1,
        autoPlay: true,
        playSpeed: 5000,
        infiniteScroll: true,
        centerMode: true,
        breakpoints: {
          1400: {
            itemsToShow: 3,
            centerMode: true,
          },
        },
      },
    };
  },
};
</script>

<style>
:root {
  --vc-clr-primary: #78150f;
  --vc-clr-secondary: #dd7f7a;
}
</style>
